var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{staticClass:"has-text-weight-bold",attrs:{"type":"is-primary"},on:{"click":_vm.exportToXlsx}},[_vm._v(" Exportieren ")])
}
var staticRenderFns = []

export { render, staticRenderFns }